import { useEffect, useState } from "react";
import Preloader from "../preloader";
import domain from "../../../reusecomponent/domain";
import { ErrorToastContainer, SuccessToastContainer } from "../../function/CustomFunction";
import { getToken } from "../../function/token";
import Template from "./template";
import Synctemplate from "./synctemplate";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";

export default function Managetemplate() {
  const {userid} = useParams();
  const [loder,setloder] = useState(false);
  const [tempalates,setTempalate] = useState([]);

  useEffect(()=>{
    setloder(true);
    const myHeaders = new Headers();
    const access_token = getToken();
    myHeaders.append("Authorization", `Bearer ${access_token}`);
  
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    const url = userid ? `${domain()}/manage-template/${userid}` : `${domain()}/manage-template`;
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setloder(false);
        if(result.status){
          setTempalate(result.data);
          SuccessToastContainer(result.message);
        }else{
          ErrorToastContainer(result.message);
        }          
      })
      .catch((error) => {
        setloder(false);
        ErrorToastContainer('Internal Server Error');
    });
  }, []);

  const DeleteTempate = (id) => {
          // Check permission before allowing delete
          // if (!hasPermission(PERMISSIONS.TEMPLATES_DELETE)) {
          //   Swal.fire({
          //     title: "Access Denied",
          //     text: "You don't have permission to delete templates.",
          //     icon: "error"
          //   });
          //   return;
          // }

          console.log('Delete template ID:', id, 'Type:', typeof id);
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to Delete this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes Delete"
        }).then((result) => {
            if (result.isConfirmed) {
              setloder(true);
              const myHeaders = new Headers();
              const access_token = getToken();
              myHeaders.append("Authorization", `Bearer ${access_token}`);
            
              const requestOptions = {
                method: "POST",
                headers: myHeaders,
              };
              // The id is already base64 encoded from the template component
              const url = userid ? `${domain()}/delete-template/${userid}/${id}` : `${domain()}/delete-template/${id}`;
              console.log('Delete template URL:', url);
              fetch(url, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                  setloder(false);
                  if(result.status){
                    setTempalate(result.data);
                    SuccessToastContainer(result.message);
                  }else{
                    ErrorToastContainer(result.message);
                  }          
                })
                .catch((error) => {
                  setloder(false);
                  console.error('Delete template error:', error);
                  ErrorToastContainer('Internal Server Error');
              });
            }
        });
  }

  // Check if user has permission to view templates
  // if (!hasPermission(PERMISSIONS.TEMPLATES_VIEW)) {
  //   return (
  //     <div className="container-fluid">
  //       <div className="row justify-content-center">
  //         <div className="col-12 text-center mt-5">
  //           <h3>Access Denied</h3>
  //           <p>You don't have permission to view templates.</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  
  return (
    <div className="col-lg-12 grid-margin stretch-card p-0 px-sm-3">
      <Preloader action={loder}/>
      <div className="card border-0 shadow-sm" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}>
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 fw-bold" style={{ fontFamily: '"Outfit", sans-serif' }}>Manage Template</h5>
            <Synctemplate setTempalate={setTempalate} setloder={setloder} userid={userid}/>
          </div>
          <div className="table-responsive" style={{overflow: 'auto !important', height: 'calc(100% - 50px)', borderRadius: '12px' }}>
            <table className="table payment-history-table">
              <thead>
                <tr>
                  <th>#id</th>
                  <th>Template Name</th>
                  <th>Language</th>
                  <th>Category</th>
                  <th>Score</th>
                  <th>Template id</th>
                  <th>Status</th>
                  <th>Edit Date</th>
                  <th>Time</th>
                  <th>Edit Template</th>
                  <th>Delete Template</th>
                </tr>
              </thead>
              <tbody>
                  {tempalates.length ? tempalates.map((tempalate,index) => (
                    
                    <Template key={index} temPlate={tempalate} index={index} DeleteTempate={DeleteTempate}/>
                  )) : <tr><td colSpan={11} className="text-center text-warning">Not Found</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}